import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Divider, Card, Button, Row, Col, Grid } from 'antd';
import TwoItemColumn from 'components/twoItemColumn';
import './LhomeContent.less';
import { MyPoliciesProps, formatNotification, InboxMessageProps } from 'utils/liHome';
import ChevronRight from 'assets/images/home/chevron-right.svg';
import PolicyMore from './policyMore';
import { useInboxQuery } from 'all-in-one-shared-api';
import { useKeycloakReady } from 'hooks';
import { isLocaleEnglish } from 'utils/languageUtils';
import { useNavigate } from 'react-router-dom';
const { useBreakpoint } = Grid;
import { MyPolicies } from 'types/life';
import { Spinner } from 'components';

type LhomeContentProps = {
  myPolicies?: MyPoliciesProps[];
  policies?: MyPoliciesProps[];
  notList?: InboxMessageProps[];
  policyBak?: MyPolicies[];
};
const KnowMoreLinkImage = styled.img`
  margin-left: 13px;
  width: 12px;
  height: 12px;
  margin-top: 5px;
`;
const Policy = ({ policies, policyBak }: LhomeContentProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  // const { lg } = useBreakpoint();
  const gotoanotherpage = (
    alertStateCode: string,
    policyNumber: string,
    companyCode: string,
    salesUnitCode?: string,
    alertPolicyUpdateStateCode?: string,
  ) => {
    if (alertStateCode) {
      if (alertStateCode === 'Issued') {
        //跳转policydetail页面
        navigate('/PoliciesCorrespondence', {
          state: {
            policyNo: policyNumber,
            companyCode: companyCode,
            salesUnitCode,
          },
        });
      } else {
        navigate('/LIPayment/PaymentDetails', {
          state: {
            policyNumber,
            companyCode,
          },
        });
      }
    } else if (alertPolicyUpdateStateCode) {
      navigate('/ChangePaymentArrangement', { state: { policyNo: policyNumber } });
    }
  };
  const gotoDetail = (policy?: MyPolicies) => {
    navigate('/PoliciesDetail', {
      state: {
        ...policy,
      },
    });
  };
  return (
    <div>
      <h3>{t('life.home.policyTitle')}</h3>
      <Row gutter={[{ xs: 8, sm: 16, md: 24 }, 16]} justify="space-between" wrap>
        {policies?.map((policy, index) => {
          return (
            <TwoItemColumn key={index}>
              <Card className="policy-card">
                <div className="top-desc" onClick={() => gotoDetail(policyBak?.[index])}>
                  <img src={policy.productCategoryUrl} alt="" className="left-icon" />
                  <div className="center-content">
                    <div
                      style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                    >
                      <p className="tagging font-setting500 letter-space4">{policy.productCategoryTitle}</p>
                      <KnowMoreLinkImage src={ChevronRight} alt="know-more-arrow" className="more" />
                    </div>
                    <h3 style={{ fontSize: '33px', fontWeight: 400, marginBottom: 0, lineHeight: '40px' }}>
                      {policy.productName}
                    </h3>
                    <span
                      className={`status font-setting700 font-size12 letter-space4 ${
                        policy.colour == 'GREEN' ? 'success' : policy.colour == 'RED' ? 'failB' : 'over'
                      }`}
                    >
                      {policy.policyStatus}
                    </span>
                    {!!policy.alertState && (
                      <div
                        className="show-status font-setting500 font-size17"
                        style={{
                          backgroundColor: `${policy.alertStateCode == 'Issued' ? '#F2FBE9' : ' #FDEEEC'}`,
                          color: `${policy.alertStateCode == 'Issued' ? '#549736' : '#E9573D'}`,
                        }}
                      >
                        {policy.alertState}
                      </div>
                    )}
                    {!!policy.alertPolicyUpdateStateCode && (
                      <div
                        className="show-status font-setting500 font-size17"
                        style={{
                          backgroundColor: '#FDEEEC',
                          color: '#E9573D',
                        }}
                      >
                        {policy.alertPolicyUpdateStateName}
                      </div>
                    )}
                    <p className="tagging tagging1 font-size17">
                      <span className="tag-content font-size17">{t('life.home.pnumber')}:</span>
                      {policy.policyNumber}
                    </p>
                    <p className="tagging font-size17">
                      <span className="tag-content font-size17">{t('life.home.insured')}:</span>
                      {policy.insuredName}
                    </p>
                    {policy.premiumDueDate && (
                      <p className="tagging font-size17">
                        <span className="tag-content font-size17">{t('life.home.pddate')}:</span>
                        {policy.premiumDueDate == policy.premCessationDate
                          ? t('life.home.application')
                          : policy.premiumDueDate}
                      </p>
                    )}
                  </div>
                </div>
                {!!policy.alertStateCode && policy.salesUnitCode != 'ZAL' && (
                  <>
                    <Divider className="bottom-divider" />
                    <div className="bottom-button font-size17 font-setting500">
                      <Button
                        type="primary"
                        block
                        size="large"
                        color="#C21B17"
                        onClick={() => {
                          gotoanotherpage(
                            policy.alertStateCode,
                            policy.policyNumber,
                            policy.companyCode,
                            policy.salesUnitCode,
                          );
                        }}
                      >
                        {policy.alertStateCode == 'Issued' ? t('life.home.policyB') : t('life.home.policyA')}
                      </Button>
                    </div>
                  </>
                )}
                {!policy.alertStateCode && !!policy.alertPolicyUpdateStateCode && policy.salesUnitCode != 'ZAL' && (
                  <>
                    <Divider />
                    <div className="bottom-button font-size17 font-setting500">
                      <Button
                        type="primary"
                        block
                        size="large"
                        color="#C21B17"
                        onClick={() => {
                          gotoanotherpage(
                            policy.alertStateCode,
                            policy.policyNumber,
                            policy.companyCode,
                            policy.salesUnitCode,
                            policy.alertPolicyUpdateStateCode,
                          );
                        }}
                      >
                        {t('life.home.setupnow')}
                      </Button>
                    </div>
                  </>
                )}
              </Card>
            </TwoItemColumn>
          );
        })}
      </Row>
    </div>
  );
};
const Notification = ({ notList }: LhomeContentProps) => {
  const { t } = useTranslation();
  const { lg } = useBreakpoint();
  const Navigate = useNavigate();
  return (
    <div>
      <h3 style={{ fontSize: lg ? '26px' : '22px' }}>{t('life.home.notification')}</h3>
      {notList?.map((not, index) => {
        return (
          <Card
            onClick={() => Navigate('/LifeInbox')}
            bordered={false}
            key={index}
            style={{ boxShadow: ' 0px 2px 4px 0px #00000033', marginBottom: '5px', cursor: 'pointer' }}
          >
            <div className="not-content">
              <span className="red-dot" style={{ visibility: not.shownDate ? 'hidden' : 'visible' }}></span>
              <div className="right">
                <div className="not-tag">
                  <span className="title-font font-size17 eplice">{not.category}</span>
                  <div style={{ display: 'flex', flexWrap: 'nowrap', alignItems: 'center' }}>
                    <span className="date font-size17 font-setting500 eplice">{not.createDate}</span>
                    <KnowMoreLinkImage src={ChevronRight} alt="know-more-arrow" className="more" />
                  </div>
                </div>
                <p className="tagging not-title font-size20 eplice">{not.messageTitle}</p>
              </div>
            </div>
          </Card>
        );
      })}
    </div>
  );
};
export const LhomeContent = ({ myPolicies, policyBak }: LhomeContentProps) => {
  const { i18n } = useTranslation();
  const isEnglish = isLocaleEnglish(i18n.language);
  const { ready, token } = useKeycloakReady();
  const { shouldFetch, data, error: inboxError } = useInboxQuery('useInboxQuery', token ?? '', '', 0, 5);
  const { xs, sm, lg } = useBreakpoint();
  const [startLoading, setStartLoading] = useState<boolean>(false);

  useEffect(() => {
    setStartLoading(true);
    shouldFetch(ready);
    if (inboxError) setStartLoading(false);
  }, [data, inboxError, ready, shouldFetch]);
  useEffect(() => {
    if (data) setStartLoading(false);
  }, [data]);
  const notList = formatNotification(data, isEnglish);

  const num = ((myPolicies?.length ?? 0) > (notList?.length ?? 0) ? myPolicies?.length : notList?.length) ?? 0;
  return (
    <Row
      className="lhome-wrapper"
      style={{
        width: '91.53%',
        margin: `${xs ? '15% auto' : sm && !lg ? '10% auto' : '6% auto'}`,
        position: 'relative',
      }}
    >
      {startLoading && (
        <div
          style={{
            width: '100%',
            position: 'absolute',
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            zIndex: 999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Spinner />
        </div>
      )}
      <Col className="left-policy" lg={16} md={13} sm={24} xs={24}>
        <Policy policies={myPolicies} policyBak={policyBak}></Policy>
        <PolicyMore url={'/LIPolicies'} target="_self"></PolicyMore>
      </Col>
      <Col lg={1} md={1} sm={0} xs={0} style={{ textAlign: 'center' }}>
        <Divider type="vertical" style={{ height: `${num != 0 ? (num / 2) * 220 + 80 : 0}px`, top: '1rem' }}></Divider>
      </Col>
      <Col className="right-notification" lg={7} md={10} sm={24} xs={24}>
        <Notification notList={notList}></Notification>
        <PolicyMore url={'/LifeInbox'} target="_self"></PolicyMore>
      </Col>
    </Row>
  );
};
